/**
 * @func isYM
 * @param {string} value - the input of the function
 * @return {boolean}
 * @desc Checks if date string fits this pattern: YYYY-MM
 * ```js
 * isYM('2020-08');
 * // returns true
 * ```
 * @memberof module:TypeCheck
 * @instance
 */
const patternYearMonth = /^\d{4}-(0[1-9]|1[012])$/;
function isYM(value) {
    return patternYearMonth.test(value);
}

export { isYM as default };
